import { render, staticRenderFns } from "./TextEditModal.vue?vue&type=template&id=3cf81f8d"
import script from "./TextEditModal.vue?vue&type=script&lang=js"
export * from "./TextEditModal.vue?vue&type=script&lang=js"
import style0 from "./TextEditModal.vue?vue&type=style&index=0&id=3cf81f8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports